/** @format */
import React from 'react';
import styled from 'styled-components';

import { ContentfulCaption } from '@toucan/client/features/contentful/components/caption';
import { ContentfulPicture } from '@toucan/client/features/contentful/components/picture';

import { styles } from './masonry-grid-image.style';
import { MasonryGridImageProps } from './type';

const StyledMasonryGridImage = styled.figure`
    ${styles}
`;

export const MasonryGridImage = ({ image, caption }: MasonryGridImageProps) => {
    if (!image) {
        return null;
    }

    return (
        <StyledMasonryGridImage>
            <ContentfulPicture image={image} />
            <figcaption>
                <ContentfulCaption caption={caption} />
            </figcaption>
        </StyledMasonryGridImage>
    );
};
